var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar",style:({ position: _vm.position })},[_c('span',{staticClass:"line",class:_vm.colorType})])
}
var staticRenderFns = []

export { render, staticRenderFns }